export default function GoldenTicket() {
    return (
        <h1>Coming soon!</h1>
    )
}